import { AuthActionType } from './auth-action-type';

export interface ResetPasswordRequestAction {
  email: string;
  type: AuthActionType.ResetPasswordRequest;
}

export const resetPasswordRequest = (
  email: string,
): ResetPasswordRequestAction => ({
  email,
  type: AuthActionType.ResetPasswordRequest,
});
